export const enumList = {
    'scType': {
        'PUBLIC': '公立',
        'PRIVATE': '私立'
    },
    'buyerType': {
        'KINDSC': '幼儿园',
        'PRISC': '小学',
        'MIDSC': '初中',
        'HIGSC': '高中',
        'NURSING_HOME': '养老院',
        'UNVSC': '大学',
        'HSPT': '医院',
        'CORP': '企事业单位',
        'GOV': '政府机关',
        'RSTNT': '社会餐饮',
        'SPMKT': '商超',
        'HOTEL': '酒店',
        'WSMKT': '批发',
        'FMMKT': '农贸',
        'PERSON': '个体',
        'PRODUCT': '生产主体',
        'CIRCULATION':'流通主体',
        'FBSUP':'餐饮保障单位',
        'SOCFB':'社会餐饮单位',
        'XJBT':'新疆生产建设兵团'
    },
    'state': {
        'TRUE': '启用',
        'FALSE': '禁用'
    },
    'togBindStatus': {
        0: '未绑定',
        1: '已绑定'
    },
    'available':{
        0: '禁用',
        1: '启用'
    },
    'forceFlag':{
        0: '否',
        1: '是'
    },
    'qualityLevel':{
        '01': 'A级',
        '02': 'B级',
        '03': 'C级',
        '99': '未评估'
    },
    'appType': {
        'MEAL_GUARD_ANDROID': '校餐卫士溯源屏安卓app',
        'REST_EAT_ANDROID': '放心食安安卓app',
        'GX_REST_EAT_ANDROID': '高新放心食安安卓app',
        'XJBT_ANDROID': '新疆兵团安卓app',
        'MORNING_DETECTOR': '晨检仪安卓app',
        'GUANGAN_MEAL_GUARD_ANDROID': '广安校餐卫士溯源屏安卓app',
        'GUANGAN_MORNING_DETECTOR': '广安晨检仪安卓app',
        'CD_MEAL_GUARD_ANDROID': '成都校餐卫士溯源屏安卓app',
        'ELECTRONIC_SCALE': '电子秤安卓app',
    },
    'foodType': {
        '01': '主食',
        '02': '荤菜',
        '03': '素菜',
        '04': '配汤',
        '05': '水果',
        '06': '饮品',
        '07': '点心',
        '99': '其它',
    },
    'acquisitionMode': {
        '1': '填报模式',
        '2': '附件模式'
    },
    'traceabilityMode': {
        '1': '填报模式',
        '2': '源本模式'
    },
    'hasCamera': {
        '0': '无',
        '1': '有'
    },
    'cameraInit': {
        '': '不初始化摄像头配置',
        'TOG': '从TOG初始化',
        'TOB': '从TOB初始化'
    },
    'isSyncTobAdminAccount': {
        '0': '否',
        '1': '是'
    },
    'togSubType': {
      'KINDSC': '幼儿园',
      'PRISC': '小学',
      'MIDSC': '初中',
      'HIGSC': '高中',
      'UNVSC': '大学',
      'HSPT': '医院',
      'NURSING_HOME': '养老院',
      'CORP': '企事业单位',
      'GOV': '政府机关',
      'RSTNT': '社会餐饮',
      'SPMKT': '商超',
      'HOTEL': '酒店',
      'WSMKT': '批发',
      'FMMKT': '农贸',
      'PERSON': '个体',
      'XJBT': '新疆生产建设兵团',
      'CIRCULATION': '流通主体',
      'PRODUCT': '生产主体'
    },
    //省平台
    'prBindType':{
        0: '未绑定',
        1: '已绑定'
    },
    'prSchoolType':{
        1: '幼儿园',
        2: '小学',
        3: '中职',
        4: '高校'
    },
    'prRemoved':{
        0: '未删除',
        1: '已删除'
    },
    'isSubEntity':{
        0: '否',
        1: '是'
    },
    'workStatus':{
        1: '正常营业',
        2: '暂停营业',
        3: '停止营业',
    },
    'onlineType':{
        1: '美团',
        2: '饿了么'
    },
    'takeOut':{
        1: '是',
        2: '否'
    },
    'entityType':{
        1: '小吃店',
        2: '快餐店',
        3: '小型餐饮',
        4: '中型餐饮',
        5: '大型餐饮',
        6: '特大型餐饮',
        7: '饮品店（含甜品站）',
        8: '集体用餐配送单位',
        9: '中央厨房',
        10: '学校（含托幼机构）食堂',
        11: '机关企事业单位食堂',
        12: '工地食堂',
        13: '其他食堂',
    },

};

// 服务器返回的枚举数据转化为中文展示
export function keyToVal(type, key) {
    return enumList[type][key]
}

// 服务器返回的枚举类型转化为中文展示
export function getKeyVal(type) {
    let obj = enumList[type];
    let propertys = [];
    Object.keys(obj).map((el) => {
        let propertysItem = {'value': el, 'label': obj[el]};
        propertys.push(propertysItem);
    });
    return propertys;
}

// 中文字符串转化为英文枚举值
export function valToKey(type, value) {
    const jsonObj = enumList[type]
    for(let key in jsonObj){
        if(jsonObj[key] === value){
            return key
        }
    }
}
